module.exports = __webpack_public_path__ + "img/ic_danger.5a353fb4.svg";